import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
export default function () {
  for (var _context, _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) objects[_key] = arguments[_key];
  return _Object$assign.apply(Object, _concatInstanceProperty(_context = [{}]).call(_context, objects));
}